 <app-navigation></app-navigation>
    <!-- <div [@routeTransitionAnimations]> -->
      <router-outlet></router-outlet>
    <!-- </div> --> 
<app-navigation-footer></app-navigation-footer>
<app-get-the-app-toast></app-get-the-app-toast>